import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';
import LoginMutation from './LoginMutation';

const LoginConnectorApollo = ({ children }) => {
  const [mutate, { loading }] = useMutation(LoginMutation);

  const createLogin = async (request) => {
    const variables = request;

    const response = await mutate({
      variables,
    });

    return response;
  };

  return children({
    login: createLogin,
    loading,
  });
};

LoginConnectorApollo.propTypes = {
  children: PropTypes.func.isRequired,
};

export default LoginConnectorApollo;
